<script>
import Layout from '@layouts/main'

import { setComputed } from '@state/helpers'

import FaqCollapse from "@components/FaqCollapse";

export default {
  components: { Layout, FaqCollapse },
  data() {
    return {
      menuActiveAlias: '',
      menuIsOpen: false,
      faqListIndex: -1,
      text: {
        'zh-TW': {
          slogan: {
            title: "竭誠歡迎您與我們聯繫",
            content: "<br class='d-block d-lg-none'>橘色涮涮屋待客如友，若您有任何疑問，<br class='d-block d-lg-none'>可先參考下方『常見問題』的解答，<br>亦可於上班時間上班時間聯絡客服人員或來信至信箱<br class='d-block d-lg-none'>，我們將竭誠為您服務。"
          }
        },
        'en': {
          slogan: {
            title: "You're welcome to contact us",
            content: "<br class='d-block d-lg-none'>If you have any questions, please see the FAQ<br>You can also call us during office hours or email us;<br> we're at your service."
          }
        }
      },
      faqList: {
        'zh-TW': [
          {
            title: '橘色涮涮屋有低消嗎？',
            content: '您好，我們沒有單人最低消費限制，歡迎前來用餐。',
          },
          {
            title: '橘色涮涮屋是否有附設停車場？',
            content: '您好，橘色一、二館附近有收費的停車場，我們也提供代客停車的服務，費用為一車200元。位於百貨內的橘色分館，皆可直接使用附設的地下停車場。',
          },
          {
            title: '橘色涮涮屋是否有壽星優惠活動？',
            content: '您好，不好意思目前無生日優惠活動。<br>但可以帶蛋糕來店慶生，不會另加收蛋糕的清潔費用。',
          },
          {
            title: '橘色涮涮屋是否有刷卡服務是否有刷卡及其他優惠？',
            content: '您好，我們有提供刷卡服務，但目前沒有與銀行搭配合作優惠以及其他優惠活動。',
          },
          {
            title: '除了上述事項，我仍有其他問題，我可以透過什麼方式詢問？',
            content:
              `您好，除了可以透過官方聯繫信箱（orangeshabu@gmail.com），也可以透過官方臉書專頁（<a target="_blank" href='https://lihi1.com/oaVSq'>https://lihi1.com/oaVSq</a>）詢問，我們會有專人儘速與您聯繫`,
          },
        ],
        'en': [
          {
            title: 'Is there any minimum order per person?',
            content: 'We do not have any minimum order; please feel free to visit our restaurant.',
          },
          {
            title: 'Do you provide parking?',
            content: 'There are pay parking lots near Orange Store One and Two. We also provide valet parking for a fee of 200 NTD per car. For Orange Shabu locations in department stores, guests can use the basement parking lots.',
          },
          {
            title: 'Are there any birthday promotions?',
            content: "We're sorry but we don't have such promotions so far.<br>You're welcome to bring your own birthday cake with no additional service charge.",
          },
          {
            title: 'Can I pay by credit card, and are there any other discount deals?',
            content: 'We take credit cards but there are no discount deals or promotional activities so far.',
          },
          {
            title: 'If I have other questions, how can I contact you?',
            content:
              `You can contact us by email  (orangeshabu@gmail.com), or via our Facebook page (<a href="https://lihi1.com/oaVSq">https://lihi1.com/oaVSq</a>), we’ll get back to you ASAP.`,
          },
        ],
      },
    }
  },
  computed: {
    ...setComputed,
    textModule() {
      return this.$route.params.lang === "zh-TW"? this.text['zh-TW']:this.text['en']
    },
    faqListModule() {
      return this.$route.params.lang === "zh-TW"? this.faqList['zh-TW']:this.faqList['en']
    }
  },
  methods: {
    setActiveAlias(alias) {
      this.menuActiveAlias = alias
    },
  },
}
</script>
<template>
  <Layout>
    <section :class="$style.sectionBanner">
      <div :class="$style.contentBox">
        <h2 v-fade-up :class="$style.title">{{textModule.slogan.title}}</h2>
        <p v-fade-up="{ delay: 3 }" :class="$style.content" v-html="textModule.slogan.content"></p>
        <div class="row flex-column flex-lg-row">
          <div v-fade-up="{ delay: 9 }" class="col" :class="$style.contactBox">
            <div :class="$style.contactBoxTitle">{{$t('global.CUSTOMER_SERVICE')}}<br>{{$t('global.HOTLINE')}}</div>
            <a target="_blank" href="tel:+886 2-2711-4636">+886-2-2711-4636</a>
          </div>
          <div v-fade-up="{ delay: 12 }" class="col" :class="$style.contactBox">
            <div :class="$style.contactBoxTitle">{{$t('global.CUSTOMER_SERVICE')}}<br>{{$t('global.EMAIL')}}</div>
            <a target="_blank" href="mailto:orangeshabu@gmail.com">orangeshabu@gmail.com</a>
          </div>
        </div>
      </div>
    </section>
    <section :class="$style.sectionFaq">
      <div class="container">
        <div class="text-center">
          <h2 v-fade-up :class="$style.title">{{ $t('global.NAV_FAQ') }}</h2>
        </div>
        <div v-fade-up>
          <FaqCollapse v-model="faqListIndex" :list="faqListModule"/>
        </div>
      </div>
    </section>
  </Layout>
</template>
<style lang="scss" module>
  .sectionBanner {
    background: transparent;
    // height: 100vh;
    // height: calc(100vh - 130px);
    padding: 190px 0 203px;
    color: #ece8de;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    @include touch {
      height: 628px;
      // padding-top: 7rem;
    }
    .contentBox {
      @include touch {
        text-align: center;
      }
      .title {
        text-align: center;
        font-size: 30px;
        letter-spacing: 10px;
        @include touch {
          font-size: 24px;
          line-height: 30px;
          letter-spacing: 4.32px;
        }
      }
      .content {
        text-align: center;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: 2px;
        margin-top: 20px;
        text-align: center;
        margin-bottom: 6rem;
        font-weight: 500;
        @include touch {
          font-size: 13px;
          line-height: 22px;
          letter-spacing: 1.56px;
          margin-bottom: 60px;
        }
      }
      .contactBox {
        position: relative;
        z-index: 1;
        @include touch {
          margin-bottom: 50px;
        }
        &:before {
          content: '';
          background-image: linear-gradient(to bottom, #ed6c00 0%, rgba(0, 0, 0, 0) 85%);
          width: 140px;
          height: 140px;
          position: absolute;
          border-radius: 100%;
          left: 5%;
          top: 0%;
          z-index: -1;
          opacity: 0.3;
          @include touch {
            left: 50%;
            width: 110px;
            height: 110px;
            margin-left: -55px;
            top: -15px;
          }
        }
        a {
          color: #ece8de;
          font-family: Palatino, serif;
          font-size: 18px;
          @include touch {
            font-size: 14px;
          }
          &:hover {
            text-decoration: none;
            color: #ed6c00;
          }
        }
        .contactBoxTitle {
          font-size: 24px;
          line-height: 36px;
          letter-spacing: 3px;
          margin-bottom: 2rem;
          color: #ece8de;
          font-weight: 500;
          @include touch {
            font-size: 19px;
            line-height: 29px;
            letter-spacing: 2.28px;
            margin-bottom: 15px;
          }
        }
      }
    }


  }
  .sectionFaq {
    padding: 25rem 0 0;
    margin-top: -20rem;
    background-image: url('@assets/images/booking/booking_bg.jpg');
    background-size: cover;
    background-position: top;
    position: relative;
    @include touch {
      padding: 32rem 0 60px;
      margin-top: -30rem;
      background-size: 2300px;
    }
    .title {
      color: #ece8de;
      border: 1px solid #bbaa9b;
      font-size: 26px;
      line-height: 26px;
      letter-spacing: 5px;
      margin: 0 auto;
      display: inline-block;
      margin-bottom: 8.5rem;
      padding: 0.85rem 1.2rem;
      @include touch {
        font-size: 19px;
        line-height: 19px;
        letter-spacing: 3.42px;
        padding: 11.5px 20px;
        margin-bottom: 50px;
      }
    }
  }
</style>
